module.exports = __webpack_public_path__ + "img/Unicorn.717be45a.png";